export const iconFontAwesomeHumanitarianRankingStar = (
	<i className="fa-solid fa-ranking-star"></i>
);
